import { createContext, useContext } from 'react';
import { useCategories } from '@/features/categories';
import { useHouseholdData } from './HouseholdDataProvider';
import { DEFAULT_DATA } from '@/shared/constants/config';

const CategoriesContext = createContext(null);

export function CategoriesProvider({ children }) {
  const { data, householdId } = useHouseholdData();
  const cats = (data && data.cats) || DEFAULT_DATA.cats;
  const categories = useCategories(cats, householdId);
  return <CategoriesContext.Provider value={categories}>{children}</CategoriesContext.Provider>;
}

export function useCategoriesContext() {
  const ctx = useContext(CategoriesContext);
  if (!ctx) throw new Error('useCategoriesContext must be used within CategoriesProvider');
  return ctx;
}
